export default __webpack_public_path__ + "static/media/Ativo-1.bbba97aa.svg";